/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_Further_Alarm_HeadlineInputs */



/**
* | output |
* | --- |
* | "Get warned before a breakdown" |
*
* @param {Go_Further_Alarm_HeadlineInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const go_further_alarm_headline = /** @type {((inputs?: Go_Further_Alarm_HeadlineInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_Further_Alarm_HeadlineInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Get warned before a breakdown")
	return /** @type {LocalizedString} */ ("Soyez prévenu avant la panne")
});